// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as Utils$OrcaPaymentPage from "../../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../../Utilities/JotaiAtoms.bs.js";
import * as DropdownField$OrcaPaymentPage from "../DropdownField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../../Utilities/DynamicFieldsUtils.bs.js";

function getPhoneCode(val) {
  return Core__Option.getOr(val.split("#")[1], "");
}

function PhoneCountryCodeDropdownField(props) {
  var __isLabelHidden = props.isLabelHidden;
  var fieldConfig = props.fieldConfig;
  var isLabelHidden = __isLabelHidden !== undefined ? __isLabelHidden : false;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(fieldConfig, localeString);
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(fieldConfig, localeString);
  var countryAndCodeList = React.useMemo((function () {
          return Utils$OrcaPaymentPage.getArray(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.phoneNumberJson), "countries");
        }), []);
  var phoneNumberCodeOptions = React.useMemo((function () {
          return Core__Array.reduce(countryAndCodeList, [], (function (acc, countryObj) {
                        var countryDict = Utils$OrcaPaymentPage.getDictFromJson(countryObj);
                        var flag = Utils$OrcaPaymentPage.getString(countryDict, "country_flag", "");
                        var code = Utils$OrcaPaymentPage.getString(countryDict, "phone_number_code", "");
                        var name = Utils$OrcaPaymentPage.getString(countryDict, "country_name", "");
                        var opt_value = flag + "#" + code;
                        var opt_label = flag + " " + name + " " + code;
                        var opt_displayValue = flag + " " + code;
                        var opt = {
                          value: opt_value,
                          label: opt_label,
                          displayValue: opt_displayValue
                        };
                        acc.push(opt);
                        return acc;
                      }));
        }), []);
  var firstOptionValue = Core__Option.getOr(Core__Option.map(phoneNumberCodeOptions[0], (function (o) {
              return o.value;
            })), "");
  var defaultDropdownValue = Core__Option.getOr(Core__Option.map(countryAndCodeList.find(function (c) {
                return Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(c), "country_code", "") === Utils$OrcaPaymentPage.defaultCountryCode;
              }), (function (c) {
              var countryDict = Utils$OrcaPaymentPage.getDictFromJson(c);
              var flag = Utils$OrcaPaymentPage.getString(countryDict, "country_flag", "");
              var code = Utils$OrcaPaymentPage.getString(countryDict, "phone_number_code", "");
              return flag + "#" + code;
            })), firstOptionValue);
  var defaultCode = getPhoneCode(defaultDropdownValue);
  var field = ReactFinalForm.useField(fieldConfig.confirmRequestWritePath, {
        initialValue: Caml_option.some(defaultCode),
        validate: validate
      });
  var match$2 = React.useState(function () {
        return defaultDropdownValue;
      });
  var setValueDropDown = match$2[1];
  var valueDropDown = match$2[0];
  var match$3 = React.useState(function () {
        return "";
      });
  var setDisplayValue = match$3[1];
  React.useEffect((function () {
          var found = Core__Option.getOr(phoneNumberCodeOptions.find(function (ele) {
                    return ele.value === valueDropDown;
                  }), DropdownField$OrcaPaymentPage.defaultValue);
          setDisplayValue(function (param) {
                return Core__Option.getOr(found.displayValue, Core__Option.getOr(found.label, found.value));
              });
        }), [
        phoneNumberCodeOptions,
        valueDropDown
      ]);
  React.useEffect((function () {
          field.input.onChange(getPhoneCode(valueDropDown));
        }), [valueDropDown]);
  return React.createElement(DropdownField$OrcaPaymentPage.make, {
              appearance: match.config.appearance,
              value: valueDropDown,
              setValue: (function (setter) {
                  setValueDropDown(function (prev) {
                        return setter(prev);
                      });
                }),
              isDisplayValueVisible: true,
              displayValue: match$3[0],
              setDisplayValue: setDisplayValue,
              fieldName: match$1.label,
              isLabelHidden: isLabelHidden,
              options: phoneNumberCodeOptions,
              disabled: false,
              width: "w-full min-w-24"
            });
}

var make = PhoneCountryCodeDropdownField;

export {
  getPhoneCode ,
  make ,
}
/* jotai Not a pure module */
